import { App } from "vue";
import CheckoutCustomizationEventBus from "../../base/ts/EventBus/CheckoutCustomizationEventBus";
import ResizeDetector from "element-resize-detector";
import QuickSearch from "./pertwo.quicksearch";
import { useCustomizationCheckoutStore } from "./stores/CustomizationCheckoutStore";
import loadComponents from "./loadComponents";
import baseBootstrap from "../../base/ts/baseBootstrap";

const app: App<Element> = baseBootstrap();
loadComponents(app);

const customizationCheckoutStore = useCustomizationCheckoutStore();
CheckoutCustomizationEventBus.on("afterOrderPay", customizationCheckoutStore.afterOrderPay);

const $ = require("jquery");
// @ts-ignore
window.$ = $;

$("document").ready(function ($) {
    let anchorLink;

    // window.location.hash might also be a non-link (like the filters hash)
    try {
        // set a variable for the anchor link which is the location.hash
        anchorLink = $(window.location.hash);
    } catch (e) {}

    // test to see if the link is a anchor link, if not the length will have no value, this is done to avoid js errors on non anchor links
    if (anchorLink?.length) {
        // set an element as the fixed entity, header in this case and get its height
        var offsetSize = $("#navbar-search").innerHeight();
        // fire the animation from the top of the page to the anchor link offsetting by the fixed elements height, the number is the speed of the animation
        $("html, body").animate({ scrollTop: anchorLink.offset().top - offsetSize }, 500);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    new QuickSearch();

    initializeExpandableSections();
});

function initializeExpandableSections() {
    let expandableSections$ = $(".expandable-section");

    expandableSections$.each(function () {
        ResizeDetector({
            strategy: "scroll",
        }).listenTo(this, () => {
            if (this.offsetHeight < this.scrollHeight) $(this).addClass("is-overflowing");
            else $(this).removeClass("is-overflowing");
        });
    });
}
